import { render, staticRenderFns } from "./rh_dashboard.vue?vue&type=template&id=0f37a4c0&"
import script from "./rh_dashboard.vue?vue&type=script&lang=js&"
export * from "./rh_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports